import { Citation } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function CitationDemo() {
  return (
    <Section
      id="citation"
      title="Citation"
      description="Source chip / card. Renderer for the K2 `citation` block - props are the streamed `{ title, url, snippet }`."
    >
      <VariantBlock label="Card">
        <Citation
          title="K2 block schema registry"
          url="https://docs.aisquare.studio/contracts/block-registry"
          snippet="Blocks are how the LLM puts rich UI in chat: widgets, sandboxed HTML, and grid dashboards."
        />
        <Citation
          title="Recharts - composable charting built on React components and D3"
          url="https://www.recharts.org/"
          snippet="A redefined chart library built with React and D3."
        />
      </VariantBlock>

      <VariantBlock label="Chip" caption="compact inline">
        <Citation variant="chip" title="Docs" url="https://docs.aisquare.studio/runtime" />
        <Citation variant="chip" title="GitHub" url="https://github.com/AISquare-Studio/aisquare-ui" />
      </VariantBlock>

      <VariantBlock label="No snippet / inert url">
        <Citation title="Title-only source" url="https://example.com/article/42" />
        <Citation title="Unresolvable source (renders inert)" url="not-a-real-url" />
      </VariantBlock>
    </Section>
  );
}
